import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from './alert.store';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

// "Email me when this location is back in stock": the customer's waiting requests, and the admin list.
export const useStockAlertStore = defineStore('stock-alert', {
    state: () => ({
        mine: [],          // my waiting requests
        loaded: false,
        saving: false,
        adminAlerts: [],
        adminLoading: false,
    }),
    actions: {
        async loadMine() {
            try {
                const res = await fetchWrapper.get(`${baseUrl}/stock-alert/mine`);
                this.mine = res.alerts || [];
                this.loaded = true;
            } catch (error) {
                this.loaded = true;   // the Buy page still works without it
            }
        },
        async create({ country, isp, city, isIpv6, email }) {
            const alertStore = useAlertStore();
            try {
                this.saving = true;
                const res = await fetchWrapper.post(`${baseUrl}/stock-alert/create`, { country, isp, city, isIpv6, email });
                if (res.alert && !this.mine.some((a) => a.id === res.alert.id)) this.mine = [res.alert, ...this.mine];
                return res.alert;
            } catch (error) {
                alertStore.error(error);
                return null;
            } finally {
                this.saving = false;
            }
        },
        async cancel(id) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/stock-alert/cancel`, { id });
                this.mine = this.mine.filter((a) => a.id !== id);
            } catch (error) {
                alertStore.error(error);
            }
        },
        async adminLoad() {
            const alertStore = useAlertStore();
            try {
                this.adminLoading = true;
                const res = await fetchWrapper.get(`${baseUrl}/admin/stock-alert/load`);
                this.adminAlerts = res.alerts || [];
            } catch (error) {
                alertStore.error(error);
            } finally {
                this.adminLoading = false;
            }
        },
        async adminDelete(ids) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/admin/stock-alert/delete`, { ids });
                this.adminAlerts = this.adminAlerts.filter((a) => !ids.includes(a.id));
            } catch (error) {
                alertStore.error(error);
            }
        },
    },
});
